import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CentralDashboardComponent from './CentralDashboardComponent';
import LayoutAction from '../../../../../modules/actions/LayoutAction';

const mapDispatchToProps = (dispatch) => {
  return {
    LayoutAction: bindActionCreators(LayoutAction, dispatch)
  };
};

export default connect(mapDispatchToProps)(CentralDashboardComponent);
